import { getActiveAdventure } from "../adventure/ActiveAdventure.js";

/**
 * Bundled portrait archetypes shipped under public/engine/portraits/.
 * Authors reference these by key in the Tiled `portrait` property on NPC objects.
 */
export const PORTRAIT_KEYS = [
  "robe",
  "armor",
  "rags",
  "elegant",
  "monstrous",
  "merchant",
] as const;

export type PortraitKey = (typeof PORTRAIT_KEYS)[number];

const PORTRAIT_KEY_SET: ReadonlySet<string> = new Set(PORTRAIT_KEYS);

/**
 * Resolve a portrait value from Tiled data to an <img> src path.
 *
 * - An absolute path or URL (starts with "/" or "http") → used as-is
 * - A known archetype key ("robe", "armor", …) → `/engine/portraits/<key>.svg`
 * - Anything else → adventure-scoped `<base>/portraits/<file>` (the
 *   adventure ships the file in its own portraits/ dir)
 */
export function resolvePortraitSrc(portrait: string): string {
  if (portrait.startsWith("/") || portrait.startsWith("http")) {
    return portrait;
  }
  if (PORTRAIT_KEY_SET.has(portrait)) {
    return `/engine/portraits/${portrait}.svg`;
  }
  return `${getActiveAdventure().baseUrl}/portraits/${portrait}`;
}
